import type { DebounceSettings } from 'lodash-es'
import debounce from 'lodash-es/debounce'
import { useEffect, useRef } from 'react'

export const useDebounce = (
  callback: (...args: any) => any,
  wait: number,
  deps?: any[],
  options?: DebounceSettings,
) => {
  const debounceRef = useRef(debounce(callback, wait, options))

  useEffect(() => {
    const currentDebounce = debounceRef.current

    debounceRef.current = debounce(callback, wait, options)

    return () => {
      currentDebounce.cancel()
    }
  }, [wait, options, ...(deps || [])])

  return debounceRef.current
}
